/* Loads every PNG in src/assets/config at build time.

   Uses require.context so the page is zero-maintenance: drop new screenshots
   into src/assets/config and they appear on the next build — no manifest to
   update, no filenames listed anywhere.

   Naming convention drives which row an image lands in:
     holo_*.png  -> Holograms
     lore_*.png  -> Lore
     everything else -> GUIs                                                  */

const context = require.context("../../assets/config", false, /\.png$/i);

function toSrc(key) {
  const mod = context(key);
  return mod && mod.default ? mod.default : mod;
}

// "lore_vote_streak.png" -> "Vote Streak"
function toLabel(fileName, prefix) {
  const base = fileName.replace(/\.png$/i, "").slice(prefix.length);
  return base
    .split(/[_-]+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

function build() {
  const holograms = [];
  const lore = [];
  const guis = [];

  context.keys().forEach(key => {
    const fileName = key.replace(/^\.\//, "");
    const lower = fileName.toLowerCase();
    const item = {id: fileName, src: toSrc(key)};

    if (lower.startsWith("holo_")) {
      holograms.push({...item, label: toLabel(fileName, "holo_")});
    } else if (lower.startsWith("lore_")) {
      lore.push({...item, label: toLabel(fileName, "lore_")});
    } else {
      guis.push({...item, label: toLabel(fileName, "")});
    }
  });

  const byLabel = (a, b) => a.label.localeCompare(b.label);
  return {
    guis: guis.sort(byLabel),
    holograms: holograms.sort(byLabel),
    lore: lore.sort(byLabel)
  };
}

const configImages = build();

export default configImages;
